import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'fb-amendment-indicator',
  templateUrl: './amendment-indicator.component.html',
  styleUrl: './amendment-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-filled]': 'filled()' },
})
export class AmendmentIndicatorComponent {
  /**
   * Whether the amendment indicator should use "filled" style.
   */
  public readonly filled = input(false, { transform: booleanAttribute });
}
